import { getMegaraxPath } from "@megaron/megarax-uri";
export const getAccountPath = (email: string) => getMegaraxPath.uri("megarax://iam/users/email/{email}", { email });
